<template>
    <div :class="[$prefixClass.modal + '-wrapper']" :data-id="modal_id" :id="modalId ? modalId : modal_id">
        <transition name="fade-in" mode="out-in">
            <div @keydown.esc="show_modal = false" :class="$prefixClass.modal + '-mask'" v-if="show_modal && mask"
                :style="{ 'z-index' : zIndexMask }"></div>
        </transition>
        <transition name="zoom-in" mode="out-in">
            <div v-if="show_modal" tabindex="-1" role="dialog" :class="[$prefixClass.modal + '-wrap']"
                :style="{ zIndex }" @click.self="clickBackdrop">
                <div role="document" :class="[$prefixClass.modal, modalBodyClass]" :style="modalBodyStyle">
                    <div :class="$prefixClass.modal + '-content'">
                        <button v-if="closable" type="button" aria-label="Close" :class="$prefixClass.modal + '-close'"
                            @click="btnClose">
                            <i class="fal fa-times"></i>
                        </button>
                        <div :class="$prefixClass.modal + '-header'" v-if="header">
                            <slot name="header">
                                <div :class="$prefixClass.modal + '-title'">
                                    {{ title }}
                                </div>
                            </slot>
                        </div>
                        <div :class="$prefixClass.modal + '-body'">
                            <slot></slot>
                        </div>
                        <div :class="$prefixClass.modal + '-footer'" v-if="footer">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    var createId = () => {
        var text = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (text() + text() + "" + text() + "" + text() + "" + text() + "" + text() + text() + text());
    }
    export default {
        name: 'VueModalCustom',
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            backdrop: {
                type: Boolean,
                default: true
            },
            width: {
                type: [Number, String],
                default: '480'
            },
            header: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: ''
            },
            footer: {
                type: Boolean,
                default: true,
            },
            closable: {
                type: Boolean,
                default: true,
            },
            zIndex: {
                type: [String, Number],
                default: 1001
            },
            mask: {
                type: Boolean,
                default: true,
            },
            zIndexMask: {
                type: [String, Number],
                default: 1000
            },
            bodyClass: {
                type: String,
                default: 'm-modal-opened'
            },
            modalBodyClass: {
                type: String,
                default: ''
            },
            keyboard: {
                type: Boolean,
                default: true
            },
            modalId: {
                type: [String, Number],
                default: 0
            },
            top: [String, Number]
        },
        data() {
            return {
                show_modal: false,
            }
        },
        computed: {
            modalBodyStyle() {
                var styles = {
                    width: this.modal_width
                }
                if (this.top) {
                    styles = Object.assign(styles, {
                        top: this.top
                    })
                } else {
                    styles = Object.assign(styles, {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                    })
                }
                return styles
            },
            visible: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },
            modal_width() {
                return this.width + 'px'
            }
        },
        methods: {
            show() {
                document.body.classList.add(this.bodyClass)
                this.visible = true
                this.show_modal = true
            },
            hide() {
                this.show_modal = false
                document.body.classList.remove(this.bodyClass);
                setTimeout(() => {
                    this.visible = false
                }, 200);
                this.$emit('on-hide')
            },
            save() {

            },
            btnClose() {
                this.hide();
            },
            clickBackdrop() {
                if (!this.backdrop) return;
                this.hide()
            },
            handleKeyboard(e) {
                if ( this.keyboard ) {
                    if (e.keyCode === 27) {
                        this.hide()
                    }
                }
                e.preventDefault()
            }
        },
        watch: {
            value(value) {
                if (value) {
                    this.show()
                } else {
                    this.hide()
                }
            }
        },
        created() {
            this.modal_id = createId()
            window.addEventListener('keyup', this.handleKeyboard)
        },
        mounted() {
            if (this.visible) {
                this.show()
            }
        },
        beforeDestroy() {
            if (this.visible) {
                document.body.classList.remove(this.bodyClass);
            }
        },
        destroyed() {
            window.removeEventListener('keyup', this.handleKeyboard)
        }
    }
</script>
